import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function OnboardingModal() {
  const { currentUser: user } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleDismiss = () => {
    if (user?.id) {
      sessionStorage.setItem(`onboarding_dismissed_${user.id}`, 'true');
    }
    setIsOpen(false);
  };

  useEffect(() => {
    // Verificamos si faltan datos críticos
    if (user) {
      const isDismissed = sessionStorage.getItem(`onboarding_dismissed_${user.id}`);
      const isIncomplete = !user.rut_profesional || !user.rol_minsal || !user.titulo_profesional;
      
      if (isIncomplete && !isDismissed) {
        // Pequeño delay para que no sea intrusivo al instante
        const timer = setTimeout(() => setIsOpen(true), 1500);
        return () => clearTimeout(timer);
      }
    }
  }, [user]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full p-8 relative animate-fade-in-up">
        
        {/* Decoración Visual (Ícono) */}
        <div className="mx-auto w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
          <svg className="w-8 h-8 text-[#2a9d8f]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h2 className="text-2xl font-bold text-center text-gray-800 mb-2">
          ¡Hola, {user?.first_name || 'Colega'}! 👋
        </h2>
        <p className="text-gray-600 text-center mb-8">
          Bienvenido a <strong>EstetikFlow</strong>. Antes de empezar a atender pacientes, 
          necesitamos configurar tus datos profesionales (RUT, ROL, Título) para que tus 
          <strong> Certificados y Recetas</strong> se generen automáticamente con validez legal.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => {
              setIsOpen(false);
              navigate('/app/configuracion'); // Redirige a la sección donde edita su perfil
            }}
            className="w-full bg-[#2a9d8f] hover:bg-[#23877a] text-white font-bold py-3 px-6 rounded-xl transition-all transform hover:scale-[1.02] shadow-lg shadow-teal-500/30"
          >
            ⚙️ Configurar mi Perfil Profesional
          </button>
          
          <button
            onClick={handleDismiss}
            className="w-full text-gray-400 text-sm font-medium hover:text-gray-600 py-2"
          >
            Lo haré más tarde (Mis documentos saldrán incompletos)
          </button>
        </div>
      </div>
    </div>
  );
}
